import type { Permission } from '~/types';

export const permissions: Permission[] = [
  { value: 9, text: 'thresholds' },
  { value: 10, text: 'manageIpWhiteListBO' },
  { value: 16, text: 'manageIpWhiteListBOAddIp' },
  { value: 43, text: 'gedList' },
  { value: 44, text: 'feesExport' },
  { value: 76, text: 'manageBoUsers' },
  { value: 77, text: 'manageBoUsersAdd' },
  { value: 78, text: 'manageBoUsersUpdate' },
  { value: 83, text: 'manageOperations' },
  { value: 87, text: 'sendPayment' },
  { value: 88, text: 'createPaymentForm' },
  { value: 106, text: 'tdb' },
  { value: 108, text: 'accessMontantCompte' },
  { value: 109, text: 'accessTodayProfit' },
  { value: 110, text: 'accessTodaySumMoneyIn' },
  { value: 111, text: 'accessTodaySumMoneyOut' },
  { value: 114, text: 'edit' },
  { value: 132, text: 'editTabOverView' },
  { value: 133, text: 'editTabDocuments' },
  { value: 137, text: 'editTabControlJournal' },
  { value: 138, text: 'addWalletComment' },
  { value: 139, text: 'editTabWalletDetail' },
  { value: 140, text: 'updateWalletDetail' },
  { value: 141, text: 'editTabBankingInformation' },
  { value: 142, text: 'editTabBankingInformationVirement' },
  { value: 144, text: 'editTabBankingInformationListeIban' },
  { value: 145, text: 'updateIbanWallet' },
  { value: 146, text: 'editTabBankingInformationAddIban' },
  { value: 147, text: 'editTabBankingInformationAddIbanSepa' },
  { value: 148, text: 'editTabBankingInformationAddIbanExtended' },
  { value: 151, text: 'editTabBankingInformationMandatSDD' },
  { value: 152, text: 'registerSddMandate' },
  { value: 153, text: 'moneyInSddInit' },
  { value: 154, text: 'unregisterSddMandate' },
  { value: 155, text: 'editTabBankingInformationRegisteredCards' },
  { value: 156, text: 'editTabOperation' },
  { value: 159, text: 'refundMoneyIn' },
  { value: 160, text: 'moneyInValidate' },
  { value: 163, text: 'cancelMoneyTransactionIn' },
  { value: 164, text: 'cancelMoneyTransactionOut' },
  { value: 165, text: 'moneyOutPdfConfirm' },
  { value: 166, text: 'proofPaymentPdf' },
  { value: 171, text: 'proEdit' },
  { value: 176, text: 'proEditTabOperations' },
  { value: 177, text: 'proEditTabControlJournal' },
  { value: 178, text: 'proEditTabBankingInformation' },
  { value: 179, text: 'proEditTabBankingInformationVirement' },
  { value: 186, text: 'displayPar' },
  { value: 188, text: 'registerWallet' },
  { value: 209, text: 'notification' },
  { value: 210, text: 'notificationHistoric' },
  { value: 211, text: 'notificationSetting' },
  { value: 263, text: 'gestionAccesBo' },
  { value: 276, text: 'documentationLW' },
  { value: 277, text: 'statusPage' },
  { value: 292, text: 'updateSdd' },
  { value: 300, text: 'proEditTabBankingInformationListeIban' },
  { value: 310, text: 'proAddWalletComment' },
  { value: 313, text: 'proCancelMoneyTransactionIn' },
  { value: 314, text: 'proCancelMoneyTransactionOut' },
  { value: 316, text: 'proMoneyInValidate' },
  { value: 317, text: 'proMoneyOutPdfConfirm' },
  { value: 319, text: 'proProofPaymentPdf' },
  { value: 320, text: 'proRefundMoneyIn' },
  { value: 332, text: 'notificationSettingUpdate' },
  { value: 405, text: 'cancelMoneyInBySDD' },
  { value: 406, text: 'cancelMoneyInByCheck' },
  { value: 407, text: 'proCancelMoneyInBySDD' },
  { value: 408, text: 'proCancelMoneyInByCheck' },
  { value: 417, text: 'uploadDocument' },
  { value: 444, text: 'doWalletUnFreezeReasonPartner' },
  { value: 449, text: 'doWalletFreezeReasonPartner' },
  { value: 455, text: 'closeIban' },
  { value: 463, text: 'apiKeys' },
  { value: 464, text: 'postIdent' },
  { value: 465, text: 'twoFa' },
  { value: 478, text: 'walletStatement' },
  { value: 479, text: 'reports' },
  { value: 480, text: 'closeViban' },
  { value: 481, text: 'requestWireTransfer' },
  { value: 482, text: 'proRequestWireTransfer' },
  { value: 483, text: 'validateWireTransfer' },
  { value: 484, text: 'proValidateWireTransfer' },
  { value: 485, text: 'editBranding' }
];
